import { Component } from "@theme/component";

class SaleCollectionComponent extends Component {
  requiredRefs = ["products", "count"];

  connectedCallback() {
    super.connectedCallback();
    this.activeScent = "all";
    this.activeSort = "relevance";
    this.baseOrder = [...this.refs.products];
  }

  handleScentClick(event) {
    const item = event.target.closest("li");
    const filterGroup = event.target.closest("[data-type='scent']");
    if (!item || !filterGroup) return;

    this.activeScent = item.dataset.handle || "all";
    const list = filterGroup.querySelector(".collections-list-filters-options");
    if (list && item.parentElement === list) {
      list.prepend(item);
    }
    filterGroup.querySelector("ul")?.blur();
    this.applyFilters();
  }

  handleSortClick(event) {
    const item = event.target.closest("li");
    const filterGroup = event.target.closest("[data-type='sort']");
    if (!item || !filterGroup || !item.dataset.handle) return;

    this.activeSort = item.dataset.handle;
    const list = filterGroup.querySelector(".collections-list-filters-options");
    if (list && item.parentElement === list) {
      list.prepend(item);
    }
    filterGroup.querySelector("ul")?.blur();
    this.applyFilters();
  }

  applyFilters() {
    const products = this.baseOrder;

    products.forEach((product) => {
      const matchesScent =
        this.activeScent === "all" ||
        product.dataset.scent === this.activeScent;

      product.classList.toggle("visible", matchesScent);
    });

    const visibleProducts = products.filter((product) =>
      product.classList.contains("visible"),
    );

    this.sortProducts(visibleProducts);
    this.updateCount(visibleProducts.length);
  }

  sortProducts(visibleProducts) {
    const grid = this.querySelector(".shavingart__sale-grid");
    if (!grid) return;

    const sorted = [...visibleProducts];

    if (this.activeSort === "price-asc") {
      sorted.sort(
        (a, b) => Number(a.dataset.price) - Number(b.dataset.price),
      );
    } else if (this.activeSort === "price-desc") {
      sorted.sort(
        (a, b) => Number(b.dataset.price) - Number(a.dataset.price),
      );
    } else if (
      this.activeSort === "relevance" ||
      this.activeSort === "popular"
    ) {
      sorted.sort(
        (a, b) => Number(a.dataset.index) - Number(b.dataset.index),
      );
    }

    sorted.forEach((product) => grid.appendChild(product));

    this.baseOrder.forEach((product) => {
      if (!product.classList.contains("visible")) {
        grid.appendChild(product);
      }
    });
  }

  updateCount(count) {
    if (!this.refs.count) return;
    const label = count === 1 ? "Product" : "Products";
    this.refs.count.textContent = `Displaying ${count} ${label}`;
  }
}

if (!customElements.get("sale-collection-component")) {
  customElements.define("sale-collection-component", SaleCollectionComponent);
}
